<div class="rest_dra">
    <div class="frm_date_dra">
        <div class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
            <div class="title d-flex align-items-center">
              <button  mat-icon-button (click)="navigate()"  class="me-3">
                <mat-icon class="material-icons-round">arrow_back</mat-icon>
              </button>
              <div>
                <h1 >{{ 'sales_report.title' | translate }}</h1>
                <h2 class="m-0" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
            
            <button *ngIf="showButton" mat-button >{{showButton}}</button>
          </div>
        <div class="ada">
            <!-- <div class="col-sm-5">
                <div class="res_fll_sed">
                    <div class="row">
                        <div class="col-sm-1">
                            <label>{{ 'sales_report.from' | translate }}</label>
                        </div>
                        <div class="col-sm-5" style="padding-left: 20px;">
                            <input type="date" name="fromDate" [(ngModel)]="fromDate">
                        </div>

                        <div class="col-sm-1">
                            <label class="ret_tde">{{ 'sales_report.to' | translate }}</label>
                        </div>
                        <div class="col-sm-5" style="padding-left: 20px;">
                            <input type="date" name="toDate" [(ngModel)]="toDate" [max]="today">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="in_btn_dra">
                    <button (click)="search()">{{ 'sales_report.search' | translate }}</button>
                </div>
            </div>
           <div class="col-sm-1"></div> -->
       
            <div class="date-range-form">
                <div class="nw_all">
                <mat-form-field appearance="outline" (click)="fromDatePicker.open()">
                  <mat-label>From Date</mat-label>
                  <input matInput [matDatepicker]="fromDatePicker" name="fromDate" [(ngModel)]="fromDate" readonly>
                  <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #fromDatePicker></mat-datepicker>
                </mat-form-field>
             </div>
             <div class="nw_all">
                <mat-form-field appearance="outline" (click)="toDatePicker.open()">
                  <mat-label>To Date</mat-label>
                  <input matInput [matDatepicker]="toDatePicker" name="toDate" [(ngModel)]="toDate" [max]="today" readonly>
                  <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #toDatePicker></mat-datepicker>
                </mat-form-field>
                </div>
              
          </div>
          <div class="search_pag">
            <button (click)="search()" mat-flat-button color="primary" type="submit">{{ 'sales_report.search' | translate }}</button>
        </div>
 


           <div class="ompad" style="display: flex;padding-top: 10px;justify-content: start; gap: 10px;">
            <mat-select style="border: 1px solid lightgray;
            padding:7px 7px;
            height: 38px;
            border-radius: 5px;    max-width: 50%; background: #fff;" [(value)]="selectedFrequency" [(ngModel)]="selectedFrequency" (ngModelChange)="changeFrequency()">
                <mat-option [value]="1" >
                  {{ 'sales_report.daily' | translate }}
                </mat-option>
                <mat-option [value]="2">
                  {{ 'sales_report.monthly' | translate }}
                </mat-option>
              </mat-select>

              <mat-select style="border: 1px solid lightgray;
              padding:7px 7px;
              height: 38px;
              border-radius: 5px;max-width: 50%;background: #fff;" [(value)]="selectedView" [(ngModel)]="selectedView" (ngModelChange)="changeView()">
                  <mat-option value="Data" >
                    {{ 'sales_report.data' | translate }}
                  </mat-option>
                  <mat-option value="Graph">
                    {{ 'sales_report.graph' | translate }}
                  </mat-option>
                </mat-select>
           </div>
         
        </div>
    </div>
    
</div>

<mat-card appearance="outlined" *ngIf="visible && !toShowGraph">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="salesReportData"
           [showPagination]="true" [itemsPerPage]="25">
           <ng-template #mychart let-rowVal="row" let-colVal="col">
            {{rowVal[colVal.columnProperty] | number:'1.2-2'}}
          </ng-template>
          <!-- Custom template for amount columns -->
          <!-- <ng-template #amountTemplate let-rowValue="row" let-colValue="col">
            Rs. {{ rowValue[colValue.columnProperty] | number:'1.2-2' }}
          </ng-template> -->
      </sm-data-table>
    </div>
  </mat-card>
  <div class="cuscrd">
    <mat-card appearance="outlined" class="custom-mat-card" >
    <sm-line-chart *ngIf="visible && toShowGraph" [dataSource]="graphData"></sm-line-chart>
  </mat-card>

  </div>
